import React, { useLayoutEffect, useRef } from "react";
import { paintCardLightShadows, paintCardLightBackground, resolveLightBlendMode } from "./ShareCardLighting";

export function CardLightBackground({ scene, lighting, lights, pixelRatio }) {
  return <>{lights.filter((light) => light.power > 0).map((light) => <BackgroundLightPool key={light.id}
    scene={scene} lighting={lighting} light={light} pixelRatio={pixelRatio} />)}</>;
}

function BackgroundLightPool({ scene, lighting, light, pixelRatio }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const canvas = ref.current;
    canvas.width = Math.max(1, Math.round(scene.width * pixelRatio));
    canvas.height = Math.max(1, Math.round(scene.height * pixelRatio));
    const context = canvas.getContext("2d");
    if (!context) return;
    context.scale(canvas.width / scene.width, canvas.height / scene.height);
    // Each pool blends with the board and earlier pools through CSS, matching
    // the export's sequential Canvas blend operations.
    paintCardLightBackground(context, scene, { ...lighting, backgroundBlendMode: "normal" }, [light]);
  }, [scene, lighting, light, pixelRatio]);
  return <canvas ref={ref} className="share-editor-light-background"
    style={{ mixBlendMode: resolveLightBlendMode(lighting.backgroundBlendMode) }} aria-hidden="true" />;
}

export default function ShareCardLightPreview({ surfaces, scene, lighting, lights, shadow, pixelRatio }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const canvas = ref.current;
    const density = Math.min(pixelRatio * Math.min(window.devicePixelRatio || 1, 2), 1800 / Math.max(scene.width, scene.height));
    canvas.width = Math.max(1, Math.round(scene.width * density));
    canvas.height = Math.max(1, Math.round(scene.height * density));
    const context = canvas.getContext("2d");
    if (!context) return;
    context.scale(canvas.width / scene.width, canvas.height / scene.height);
    paintCardLightShadows(context, surfaces, scene, lighting, lights, shadow);
  }, [surfaces, scene, lighting, lights, shadow, pixelRatio]);
  return <canvas ref={ref} className="share-editor-light-shadows" aria-hidden="true" />;
}
